// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fl4_","fullView":"styles_fullView__2YkE9"};